/**
 * VisualDownloader — admin button to download social media templates.
 *
 * Usage: <VisualDownloader kind="member|event" slug="..." />
 */
import { useState } from "react";
import { Download, ImageIcon } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const FORMATS = [
  { v: "fb", label: "Facebook (1200×630)", emoji: "📘" },
  { v: "li", label: "LinkedIn post (1200×627)", emoji: "💼" },
  { v: "feed", label: "Instagram Feed / LinkedIn Feed (1080×1350)", emoji: "📸" },
  { v: "story", label: "Instagram Story (1080×1920)", emoji: "📱" },
];

const EVENT_TEMPLATES = [
  { id: "default", label: "Standard" },
  { id: "coffee", label: "WineTech Coffee ☕" },
  { id: "monthly", label: "Monthly Meetup 📅" },
  { id: "webinar", label: "Webinar 💻" },
];

export default function VisualDownloader({ kind, slug }) {
  const [open, setOpen] = useState(false);
  const [template, setTemplate] = useState("default");
  if (!slug) return null;
  const isEvent = kind === "event";
  return (
    <div className="relative inline-block">
      <button onClick={() => setOpen(!open)} className="inline-flex items-center gap-1.5 rounded-full border border-wine-300 bg-wine-50 px-3 py-1.5 text-xs font-bold text-wine-700 hover:bg-wine-100" data-testid={`visual-toggle-${slug}`}>
        <ImageIcon className="h-3.5 w-3.5" /> Visuels social
      </button>
      {open && (
        <div className="absolute right-0 top-full z-30 mt-1 w-80 overflow-hidden rounded-2xl border border-neutral-200 bg-white shadow-xl" data-testid={`visual-menu-${slug}`}>
          {isEvent && (
            <div className="border-b border-neutral-100 bg-neutral-50 p-2">
              <div className="mb-1 text-[10px] font-bold uppercase text-neutral-500">Template</div>
              <div className="flex flex-wrap gap-1">
                {EVENT_TEMPLATES.map((t) => (
                  <button
                    key={t.id}
                    onClick={() => setTemplate(t.id)}
                    className={`rounded-full px-2 py-1 text-[10px] font-bold transition-all ${template === t.id ? "bg-wine-600 text-white" : "bg-white text-neutral-700 hover:bg-wine-50"}`}
                    data-testid={`tpl-pick-${t.id}`}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </div>
          )}
          {FORMATS.map((f) => {
            const params = new URLSearchParams({ variant: f.v });
            if (isEvent) params.set("template", template);
            return (
              <a
                key={f.v}
                href={`${BACKEND}/api/visuals/${kind}/${slug}.png?${params.toString()}`}
                target="_blank"
                rel="noreferrer"
                download={`lawinetech-${slug}-${isEvent ? template + "-" : ""}${f.v}.png`}
                className="flex items-center gap-3 border-b border-neutral-50 px-4 py-2.5 text-xs hover:bg-wine-50"
                data-testid={`visual-${f.v}-${slug}`}
              >
                <span className="text-base">{f.emoji}</span>
                <span className="flex-1 font-semibold text-neutral-800">{f.label}</span>
                <Download className="h-3 w-3 text-wine-600" />
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
